{{column.label}}
<sort-icon [icon]="column.icon" [direction]="direction" ></sort-icon>
<ng-content></ng-content>